// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cosmos Unchained API
 * Provides access to cosmos chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about the running coinstack
 * @export
 * @interface Info
 */
export interface Info {
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    network: string;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    annualProvisions: string;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    apr: string;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    bondedTokens: string;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    communityTax: string;
    /**
     * 
     * @type {string}
     * @memberof Info
     */
    totalSupply: string;
}

/**
 * Check if a given object implements the Info interface.
 */
export function instanceOfInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "network" in value;
    isInstance = isInstance && "annualProvisions" in value;
    isInstance = isInstance && "apr" in value;
    isInstance = isInstance && "bondedTokens" in value;
    isInstance = isInstance && "communityTax" in value;
    isInstance = isInstance && "totalSupply" in value;

    return isInstance;
}

export function InfoFromJSON(json: any): Info {
    return InfoFromJSONTyped(json, false);
}

export function InfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Info {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'network': json['network'],
        'annualProvisions': json['annualProvisions'],
        'apr': json['apr'],
        'bondedTokens': json['bondedTokens'],
        'communityTax': json['communityTax'],
        'totalSupply': json['totalSupply'],
    };
}

export function InfoToJSON(value?: Info | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'network': value.network,
        'annualProvisions': value.annualProvisions,
        'apr': value.apr,
        'bondedTokens': value.bondedTokens,
        'communityTax': value.communityTax,
        'totalSupply': value.totalSupply,
    };
}

